import { render } from "./IconMessage.vue?vue&type=template&id=d6fee748&lang=pug&bindings={\"id\":\"props\"}"
import script from "./IconMessage.vue?vue&type=script&lang=js"
export * from "./IconMessage.vue?vue&type=script&lang=js"
script.render = render

export default script